import TxTree from './TxPlugin/TxTree/TxTree.vue';


const components = [
  TxTree
]

const install = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component);
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  TxTree
}


// WEBPACK FOOTER //
// ./src/index.js